import React, { useState, useEffect, useMemo } from "react";
import "./VocabMatch.css";

export default function VocabMatch({ data, onCorrect }) {
  const [terms, setTerms] = useState([]);
  const [defs, setDefs] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedDef, setSelectedDef] = useState(null);
  const [matches, setMatches] = useState({});

  // Memoize cards so the effect doesn't see it as changing every render
  const cards = useMemo(() => data?.cards || [], [data?.cards]);

  useEffect(() => {
    if (!cards.length) return;
    console.log("Initializing words and definitions once");

    const wordsList = cards.map((c) => c.word);
    const defsList = cards.map((c) => c.definition);

    setTerms(wordsList);
    setDefs(defsList);
  }, [cards]); // now safe to depend on 'cards'

  useEffect(() => {
    if (!selectedTerm || !selectedDef) return;

    const correctPair = cards.find(
      (c) => c.word === selectedTerm && c.definition === selectedDef
    );

    if (correctPair) {
      console.log("Correct pair found:", correctPair);

      setMatches((prev) => ({
        ...prev,
        [selectedTerm]: selectedDef,
      }));

      setTerms((t) => t.filter((term) => term !== selectedTerm));
      setDefs((d) => d.filter((def) => def !== selectedDef));

      if (onCorrect) onCorrect();
    }

    setSelectedTerm(null);
    setSelectedDef(null);
  }, [selectedTerm, selectedDef, cards, onCorrect]);

  return (
    <div className="vocab-match-wrapper">
  <h2>{data.quizTitle}</h2>

  <div className="columns">
    {terms.map((term, index) => (
      <div className="row" key={term}>
        <div
          className={`item ${selectedTerm === term ? "selected" : ""}`}
          onClick={() => setSelectedTerm(term)}
        >
          {term}
        </div>

        <div
          className={`item ${selectedDef === defs[index] ? "selected" : ""}`}
          onClick={() => setSelectedDef(defs[index])}
        >
          {defs[index]}
        </div>
      </div>
    ))}
  </div>

  <div className="matched-pairs">
    <h3>Matched Pairs:</h3>
    <ul>
      {Object.entries(matches).map(([term, def]) => (
        <li key={term}>
          <strong>{term}</strong> → {def}
        </li>
      ))}
    </ul>
  </div>
</div>
  );
}
